var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3C0.5 1.34315 1.84315 0 3.5 0H11.5C15.366 0 18.5 3.13401 18.5 7V17C18.5 18.6569 17.1569 20 15.5 20H3.5C1.84315 20 0.5 18.6569 0.5 17V3ZM10.5 2H3.5C2.94772 2 2.5 2.44772 2.5 3V17C2.5 17.5523 2.94772 18 3.5 18H15.5C16.0523 18 16.5 17.5523 16.5 17V7H10.5V2ZM16.084 5C15.4413 3.52906 14.1113 2.4271 12.5 2.10002V5H16.084Z",
    fill: "#606474"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-file.5d0ea7b2.svg";
export { ForwardRef as ReactComponent };